import type {BookingResourceUsageQueryOptions} from '@/api/queries/queries/booking/useBookingResourceUsageQuery';
import type {DateRange} from '@/api/models/dateTime/dateRange';
import type {QueryKey} from '@tanstack/vue-query';
import {get} from '@vueuse/core';
import {computed, type MaybeRef} from 'vue';

export const bookingKey = 'booking';

export const resourceUsageKey = [bookingKey, 'resourceUsage'];

export function bookingResourceUsageKey({
    distinctSelectedDates,
    currentView,
    userMeBookingForId,
    userId,
}: BookingResourceUsageQueryOptions): QueryKey {
    return [...resourceUsageKey, distinctSelectedDates, currentView, userMeBookingForId, userId];
}

export const bookingForAllowedKey = [bookingKey, 'bookingForAllowed'] as const;

export const bookingStateKey = 'bookingState';

export function bookingStateQueryKey({
    resourceId,
    selectedDates,
    userMeBookingForId,
}: {
    resourceId: MaybeRef<string>;
    selectedDates: MaybeRef<DateRange[]>;
    userMeBookingForId: MaybeRef<string | undefined>;
}): QueryKey {
    return [
        bookingKey,
        bookingStateKey,
        resourceId,
        computed(() => get(selectedDates).map(d => `${d.from.format()}|${d.to.format()}`)),
        userMeBookingForId,
    ];
}
